if (window.location.href.indexOf('/liity-jaseneksi') !== -1 || window.location.href.indexOf('/kertakaynti') !== -1) {
  if(document.getElementById("js-copy")) {
    document.getElementById("js-copy").addEventListener("click", copyCardNumber);
  }
  function copyCardNumber() {
    var copyText = document.getElementById("js-card-number");
    var textArea = document.createElement("textarea");
    textArea.value = copyText.textContent;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("Copy");
    textArea.remove();
  }
}
